module.exports = __webpack_public_path__ + "static/beach2020-3c9548c3f8486258ecf0d6a9c0bbf75f.jpg";